export default [
  require("/vercel/path0/node_modules/@docusaurus/plugin-google-gtag/lib/gtag"),
  require("/vercel/path0/node_modules/infima/dist/css/default/default.css"),
  require("/vercel/path0/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/vercel/path0/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/vercel/path0/src/css/custom.css"),
  require("/vercel/path0/node_modules/@docusaurus/plugin-pwa/lib/registerSw.js"),
];
